import { ProfileTranslationsCs } from '../Pages/Profile/translations/cs';

export const UserPageTranslationsCs = { profilePage: ProfileTranslationsCs };
